module.exports = __webpack_public_path__ + "img/cert14.e4c3f56d.png";